import React, { Fragment, useEffect } from "react";
import { Form, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";

import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";

import {
  getToken,
  getUserInfo,
  setCurrentForm,
  setFormProps,
  setModalOpen,
} from "@/reducers/commonSlice";
import { changePassword } from "@/services/accounts/createNewPassword";

import IconBackArrow from "@/components/icons/IconBackArrow";

import "@/styles/pages/auth/change-password.scss";
import useTriggerNotification from "@/hooks/useTriggerNotification";

const SetNewPassword = ({ isOpen = false }) => {
  const dispatch = useDispatch();
  const token = useSelector(getToken);
  const { trigger, element } = useTriggerNotification();
  const [form] = Form.useForm();
  const userData = useSelector(getUserInfo);

  const handleSubmit = (value) => {
    changePassword({
      currentPassword: value.currentPassword,
      password: value.password,
      token: token,
    })
      .then((response) => {
        dispatch(setModalOpen(false));
        trigger({
          type: "success",
          message: "Password updated successfully",
        });
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.msg;
        if (errorMessage) {
          switch (errorMessage) {
            case "Incorrect password":
              form.setFields([
                {
                  name: "currentPassword",
                  errors: ["Please enter a valid password."],
                },
              ]);
              break;
            // Add more cases as needed
          }
        }
      });
  };

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen]);

  return (
    <Fragment>
      {element}
      <ModalComponent isOpen={isOpen} className="onboarding-modal">
        <div className="change-password-modal">
          <div className="heading">
            <div className="flex gap-8 align-center">
              <IconBackArrow
                className="cursor-pointer"
                onClick={() => dispatch(setModalOpen(false))}
              />
              <div className="title-h5">Password</div>
            </div>
          </div>
          <div className="form">
            <Form
              form={form}
              name="register"
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={handleSubmit}
            >
              <Form.Item
                label="Current Password"
                name="currentPassword"
                rules={[
                  {
                    required: true,
                    message: "Please enter your current password.",
                  },
                ]}
              >
                <Input.Password placeholder="Enter your current password" />
              </Form.Item>
              <div className="forgot-password body-b4-1">
                <span
                  onClick={() => {
                    dispatch(setCurrentForm("forgotPassword"));
                    dispatch(
                      setFormProps({
                        email: userData?.user?.email,
                        mobileNumber: userData?.user?.mobileNumber,
                      })
                    );
                  }}
                >
                  Forgot password?
                </span>
              </div>
              <Form.Item
                label="New Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your new password.",
                  },
                  {
                    min: 8,
                    message: "Password must be at least 8 characters long.",
                  },
                  {
                    //check current password and new password and should not match
                    validator: async (_, value) => {
                      if (value && value === form.getFieldValue("currentPassword")) {
                        return Promise.reject(
                          new Error("New password should not be same as current password.")
                        );
                      }
                    },
                  },
                ]}
              >
                <Input.Password placeholder="Enter your new password" />
              </Form.Item>
              {/* <Form.Item
                label="Re-enter new Password"
                name="newPassword"
                dependencies={['password']}
                rules={[
                  {
                    required: true,
                    message: "Please enter your new password!",
                  },
                  {
                    min: 8,
                    message: "Password must be at least 8 characters long.",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || value.length < 8) {
                        return Promise.resolve();
                      }
                      if (getFieldValue('password') !== value) {
                        return Promise.reject(new Error('Entered password does not match the current password, please try again.'));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Enter your new password" />
              </Form.Item> */}
              <Form.Item>
                <div className="button">
                  <ButtonComponent label="Update Password" varient="primary" htmlType="submit" />
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default SetNewPassword;
